import React, { useEffect } from 'react';
import { batch, useSelector, useDispatch } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import filterAction from '../../actions/filterAction';

const Sfiltered = () => {
  const location = useLocation();
  const { countrySlug, scientificNameSlug, referenceId} = useParams();
  const { allMarkers } = useSelector(s => s.markers);
  const { speciesStudyList } = useSelector(s => s.species);
  const { countryStudyList } = useSelector(s => s.country);
  const { referenceStudyList } = useSelector(s => s.reference);
  const setApp = useDispatch();
  const { label, id } = useSelector(s => s.filtered);
  const { allStudies } = useSelector(s => s.allStudies);
  const { prevStudyID } = useSelector(s => s.studyDetail);
  const [list, setList] = useImmer([]);

  const [rootSlug, firstSlug] = location.pathname.split('/');

  useEffect(() => {
    if (
      allMarkers && (
        scientificNameSlug || countrySlug || referenceId
      ) && (
        speciesStudyList || countryStudyList || referenceStudyList
      )
    ) {
      const filteredData = {}
      let sbBlock = 'Search';
      let filterSlug = '';

      if (scientificNameSlug && speciesStudyList) {
        const filtered = speciesStudyList.find(
          s => s.scientificNameSlug === scientificNameSlug
        );
        filteredData.sid = filtered.studyId;
        filteredData.label = `Species (<b>${filtered.scientificName}</b>)`;
        sbBlock = 'Species';
        filterSlug = scientificNameSlug;
      }

      if (countrySlug && countryStudyList) {
        const filtered = countryStudyList.find(
          d => d.countrySlug === countrySlug
        );
        filteredData.sid = filtered.studyId;
        filteredData.label = `Species (<b>${filtered.country}</b>)`;
        sbBlock = 'Countries';
        filterSlug = countrySlug;
      }

      if (referenceId && referenceStudyList) {
        const filtered = referenceStudyList.find(
          d => d.referenceId === parseInt(referenceId)
        );
        filteredData.sid = filtered.studyId;
        filteredData.label = `Publication (<b>${filtered.bibliographicCitation	}</b>)`;
        sbBlock = 'References';
        filterSlug = referenceId;
      }

      if (filteredData.sid) {
        batch(() => {
          setApp(filterAction({
            allMarkers,
            sid: filteredData.sid,
            label: filteredData.label,
            filterSlug
          }));
          setApp({ type: '_SIDEBAR', payload: ['sbBlock', sbBlock] });
        });
      }
    }
  }, [
    allMarkers,
    countrySlug,
    countryStudyList,
    scientificNameSlug,
    speciesStudyList,
    referenceId,
    referenceStudyList
  ]);

  useEffect(() => {
    if (label) {
      setList(allStudies.filter(v => id.indexOf(v.studyId) >= 0))
    }

    return () => {
      setList([]);
    };
  }, [label]);

  if (!label) {
    return null;
  }

  return (
    <div id="filtered" className="sb-body-inner">
      <Link to={
        prevStudyID
          ? `/study/${prevStudyID}`
          : `${rootSlug}/${firstSlug || ''}`
      }>
        <button className="btn btn-border btn-gb" onClick={() => {
          batch(() => {
            if (prevStudyID) {
              setApp({
                type: '_STUDY_DETAIL',
                payload: [
                  'studyID',
                  Array.isArray(prevStudyID)
                    ? prevStudyID
                    : [prevStudyID]
                ]
              });
              setApp({
                type: '_STUDY_DETAIL',
                payload: ['prevStudyID', null]
              });
            } else {
              setApp({ type: '_FILTERED', payload: ['label', null] });
              setApp({ type: '_MARKERS', payload: ['filteredExtent', null] });
              setApp({ type: '_MARKERS_INIT'});
            }
          })

        }}><i className="fa fa-chevron-left"></i>&nbsp;&nbsp;Go Back</button>
      </Link>

      <h6 className="sb-filter-text" style={{marginTop: 45,marginBottom: 0}}>FILTERED STUDIES</h6>
      <p dangerouslySetInnerHTML={{__html:`By ${label}`}}></p>
      <div id="sb-filter-list">
        {!list.length ? null : (<span id="sb-total-projects">Total: <b>{list.length}</b> Stud{list.length > 1 ? 'ies' : 'y'}</span>)}
      </div>

      <div className="sb-project-list">
        {
          list && (
            <ul className="list-unstyled">
            {
              list.map((d) => {

                return (
                  <li role="presentation" key={d.studyId}
                    onClick={() => {
                      batch(() => {
                        setApp({
                          type: '_STUDY_DETAIL',
                          payload: ['studyID', [d.studyId]]
                        });
                        setApp({
                          type: '_STUDY_DETAIL',
                          payload: ['studyTitle', d.title]
                        });
                      });
                  }}>
                    <Link to={`/study/${d.studyId}`}>{d.title}</Link>
                  </li>
                )

              })
            }
            </ul>
          )
        }
      </div>
    </div>
  )
};

export default Sfiltered;
